/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     SystemControl
//   Details:    System control : store
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 101886 02/07/19 JHT M01  Added getLocal
// 104759 11/12/19 JC  M02  Navigator now soft coded, based on system control configuration
//-------------------------------------------------------
*/
import { alertActions } from './Alerts';
import { fetchActions } from "../FetchWrapper";
import { lifetimeActions } from './Lifetime';//M02

const systemControlRequestType = 'SYSTEMCONTROL_REQUEST';
const systemControlSuccessType = 'SYSTEMCONTROL_SUCCESS';
const systemControlFailureType = 'SYSTEMCONTROL_FAILURE';

let systemControl = JSON.parse(localStorage.getItem('systemControl'));

const initialState = {
	configuration: systemControl || { companyName: " "}
};

export const systemControlActions = {
    get, 
    getLocal //M01
};

function get() {
	return (dispatch, getState) => {
		if (!getState().clientConfiguration.config.endpoint)
			return;

		dispatch(_request());

		const url = getState().clientConfiguration.config.endpoint + "/systemcontrol";
		const ticket = getState().authentication.user.ticket;

		fetchActions.get(url, ticket)
			.then(
				response => {
					var configuration = response.data;
					localStorage.setItem('systemControl', JSON.stringify(configuration));
                    dispatch(_success(configuration));

                    //M02
                    dispatch(lifetimeActions.onLogInExtended(configuration));
				},
				error => {
					var message = `Could not get system control information: ${error}`;
					dispatch(_failure(message));
					dispatch(alertActions.error(message));
				}
			);
	};

	function _request(configuration) { return { type: systemControlRequestType, configuration }; }
	function _success(configuration) { return { type: systemControlSuccessType, configuration }; }
	function _failure(error) { return { type: systemControlFailureType, error }; }
}

// --------------------------------------------------------------
// M01 get the existing localStore copy 
function getLocal() {
    let sysCtrl = JSON.parse(localStorage.getItem('systemControl')); 
    return sysCtrl;
}

export const reducer = (state, action) => {
	state = state || initialState;

	if (action.type === systemControlRequestType) {
		return { ...state };
	}

	if (action.type === systemControlSuccessType) {
		return { ...state, configuration: action.configuration };
	}

	if (action.type === systemControlFailureType) {
		return { ...state };
	}
	return state;
};